export const SEGMENT_SKU_VIEWED_SOURCE = 'marketplace';
export const SEGMENT_DEPLOYABLE_NAME = 'banking-shopping-client';
export const SEGMENT_DEPLOYABLE_VERSION = '1.0.0';
